module.exports = __webpack_public_path__ + "img/112.9.45abb6f0.png";